export function roundValueOffset(step: number, minValue: number, maxValue: number) {
  return (value: number) => {
    if (value === minValue) {
      return minValue;
    }
    // Maxvalue can't be reached with the roundoff option
    // So we check againt the highest possible selected value example:
    // 24954 = maxValue - the difference of the modulo, in that case we use the maxvalue
    if (value === maxValue - (step - (value % step))) {
      return maxValue;
    }
    return value - (value % step);
  };
}
